export default __webpack_public_path__ + "static/media/arrow-up.aaba165f.svg";